import { buttonStyles } from './button-styles';
import { cardStyles } from './card';
import { modalStyle } from './modal';
import { textStyles } from './text-styles';

import { twSort } from '../../utils';

export const defaultTheme = {
  text: textStyles,
  // Alert
  alert: {
    base: twSort`border-c-border text-accent-light relative rounded-2xl border bg-gray-50 p-4 pl-12 text-sm leading-5`,
    withClose: twSort`pr-12`,
    success: twSort`border-green-200 bg-green-50`,
    error: twSort`border-red-200 bg-red-100`,
    warning: twSort`border-yellow-200 bg-yellow-50`,
    neutral: twSort``,
    info: twSort`border-blue-200 bg-blue-50`,

    icon: {
      base: twSort`size-5`,
      success: twSort`text-success`,
      error: twSort`text-error`,
      warning: twSort`text-warning`,
      neutral: twSort`text-accent-light`,
      info: twSort`text-info`,
    },
  },

  // Button
  button: buttonStyles,

  card: cardStyles,

  modal: modalStyle,

  // Pagination
  pagination: {
    base: twSort`flex flex-col justify-between text-xs text-gray-600 sm:flex-row`,
  },
  // TableFooter
  tableFooter: {
    base: twSort`text-c-card-muted border-t bg-gray-50 px-4 py-3`,
  },
  // TableRow
  tableRow: {
    base: twSort``,
  },
  // TableHeader
  tableHeader: {
    base: twSort`text-c-card-foreground border-b bg-gray-50 text-left text-xs font-semibold tracking-wide uppercase`,
  },
  // TableContainer
  tableContainer: {
    base: twSort`w-full overflow-hidden rounded-lg ring-1 ring-black/5`,
  },
  // TableCell
  tableCell: {
    base: twSort`px-4 py-3`,
  },
  // TableBody
  tableBody: {
    base: twSort`text-accent-light divide-y bg-white`,
  },
  // DropdownItem
  // this is the <li> that lives inside the Dropdown <ul>
  // you're probably looking for the dropdownItem style inside button
  dropdownItem: {
    base: twSort`mb-2 last:mb-0`,
  },
  // Dropdown
  dropdown: {
    base: twSort`min-w-max-content text-accent-light absolute z-10 mt-2 w-56 rounded-lg border border-gray-100 bg-white px-6 py-4 shadow-md`,
    align: {
      left: twSort`left-0`,
      right: twSort`right-0`,
    },
  },

  // Avatar
  avatar: {
    base: twSort`text-c-card-muted bg-c-avatar! border-c-border-muted relative flex shrink-0 grow-0 overflow-hidden rounded-full border`,
    size: {
      lg: twSort`size-10`,
      base: twSort`size-8`,
      sm: twSort`size-6`,
    },
  },

  // Badge
  badge: {
    base: twSort`inline-flex min-w-16 items-center justify-center rounded-md leading-5 font-normal capitalize`,
    size: {
      xs: twSort`min-w-12 px-1.5 py-1 text-[0.575rem]`,
      sm: twSort`px-1.5 text-[0.625rem]`,
      base: twSort`px-2 text-xs`,
      lg: twSort`px-2.5 py-1 text-sm`,
    },

    as: {
      light: {
        success: twSort`bg-success-x-light text-success-medium`,
        error: twSort`bg-error-x-light text-error`,
        warning: twSort`text-warning-dark bg-warning-x-light`,
        info: twSort`bg-info-x-light text-info`,
        neutral: twSort`text-c-card-muted bg-gray-50 dark:bg-gray-900`,
        primary: twSort`bg-primary-x-light text-primary`,
      },
      base: {
        success: twSort`bg-success-dark px-3 text-white`,
        error: twSort`bg-error-dark text-white`,
        warning: twSort`bg-warning text-white`,
        info: twSort`bg-info text-white`,
        neutral: twSort`text-accent-light bg-gray-50 dark:bg-gray-900 dark:text-white`,
        primary: twSort`bg-primary-light text-white`,
      },
    },
  },

  // Backdrop
  backdrop: {
    base: twSort`fixed inset-0 z-30 flex bg-gray-950/60 sm:items-center sm:justify-center dark:bg-white/30`,
  },

  checkbox: {
    base: twSort`form-checkbox border-c-border text-primary cursor-pointer rounded-xs bg-transparent`,
    active: twSort`form-checkbox:dark:border-primary focus:border-primary focus:ring-primary-light focus:ring-3 focus:ring-offset-0 focus:outline-hidden`,
    disabled: twSort`disabled:text-accent-disabled disabled:border-c-border disabled:cursor-not-allowed disabled:bg-gray-50`,
  },

  // Radio
  radio: {
    base: twSort`form-radio text-primary cursor-pointer`,
    active: twSort`border-c-border focus:border-primary focus:ring-primary-light focus:ring-3 focus:ring-offset-0 focus:outline-hidden`,
    disabled: twSort`disabled:text-accent-disabled hover:disabled:text-accent-disabled disabled:border-c-border disabled:cursor-not-allowed disabled:bg-gray-50`,
  },

  // HelperText
  helperText: {
    base: twSort`text-xs`,
    valid: twSort`text-success`,
    invalid: twSort`text-error`,
  },

  spinner: {
    base: twSort`border-primary relative inline-block shrink-0 rounded-full after:absolute after:rounded-full after:bg-white`,
    size: {
      xs: twSort`size-4 border-4 after:top-1 after:-left-1 after:size-1`,
      sm: twSort`size-6 border-[0.375rem] after:top-1 after:-left-1.5 after:size-1.5`,
      base: twSort`size-8 border-8 after:top-2 after:-left-2 after:size-2`,
    },
  },
};

export type CustomThemeType = typeof defaultTheme;
